import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/company/@section6/page.tsx");
